/**
 * Created by filatov on 14.08.2015.
 */
import Ext from 'Ext'
import UsersSelectorPanel from '../usersSelector/at_users_selector_panel'
import SwitcherWithWrapper from '../components/SwitcherWithWrapper'
import $ from 'jquery'
import messageResource from '../messageResource'
import ReportsUsersSelectorFilter from './ReportsUsersSelectorFilter'
import ReportsUserSelectorTreeBuilderObserver from './ReportsUserSelectorTreeBuilderObserver'
import {userNameLower} from '../util/pluralizeUtils'
import {arrayToMap} from '../atUtils'

const ReportsSelectorUsersPanel = Ext.extend(UsersSelectorPanel, {
    allUsersOptionLabelKey: "users_selector.reports.all_users",
    teamUsersItemsOptionLabelKey: "users_selector.reports.team_users",
    teamUsersAndMeOptionLabelKey: "users_selector.reports.team_users_and_me",
    customOptionLabelKey: "users_selector.reports.selected_users",
    showInactiveLabelKey: "users_selector.reports.show_disabled",
    predefinedState: null,
    hasPanel: true,
    resetOnHide: false,
    allUsersAvailable: true,
    loggedInUserNotInTeam: false,

    setSelectorFilter: function() {
        this.selectorFilter = new ReportsUsersSelectorFilter({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            myTeamNodesSet: this.treeBuilderObserver.getManageableUsersNodeSet(),
            accessibleParentNodes: this.treeBuilderObserver.getAccessibleParentNodes(),
            showTeamOnly: this.showTeamOnly
        });
    },

    createUserSelectorTreeBuilderObserver: function(searchIndex, allActiveSet) {
        this.treeBuilderObserver = new ReportsUserSelectorTreeBuilderObserver({
            searchIndex,
            allActiveSet,
            manageableUsersIdsSet: this.manageableUsersIdsSet
        })
        return this.treeBuilderObserver
    },

    initialize: function ( {userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly} )
    {
        const state =  this.isAlreadyShown() ? this.getState() : this.predefinedState;
        this.manageableUsersIdsSet = manageableUsersIds && manageableUsersIds.length > 0 ? new Set(manageableUsersIds) : null

        if( !state.optionValue && !state.showInactive )
        {
            const selectedUserIds = state.selection.getSecondLevel();

            for( let i = 0; i < users.length; i++ )
            {
                if( selectedUserIds.indexOf( users[i].id ) !== -1 )
                {
                    if( !users[i].active )
                    {
                        state.showInactive = true;
                        break;
                    }
                }
            }
        }

        ReportsSelectorUsersPanel.superclass.initialize.call( this, userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups );

        this.showTeamOnly = showTeamOnly
        this.showTeamOnlyInit = showTeamOnly
        this.alreadyShown = false;
        this.clearPanel();
        
        this.loadState( state );

        this.selectorFilter.setShowInactive(state.showInactive);
    },

    getDescription: function(selectionHelper, dropdownButtonId) {
        const selectedVisibleNodeSet = this.selectorFilter.getVisibleNodeSet(this.getSelectedNodeSet())

        if (this.showTeamOnly) {
            const selectedUsers = arrayToMap(this.userSelectorGroupsStrategy.makeOnlyUsersSelection(selectedVisibleNodeSet))
            const manageableUsersNodeSet = this.treeBuilderObserver.getManageableUsersNodeSet().map[2]
            const selectedGroups = selectedVisibleNodeSet.map[1]
            if (!!manageableUsersNodeSet && !!selectedGroups) {
                Object.values(manageableUsersNodeSet).forEach(node => {
                    if (!!node.parent && !!selectedGroups[node.parent.id]) {
                        selectedUsers[node.value.id] = node.value
                    }
                })
            }

            const selectedUsersArray = Object.values(selectedUsers)
            const selectedUsersLength = selectedUsersArray.length

            if (selectedUsersLength === 0) {
                return messageResource.getEscapedMessage("users_selector.short_no_users_selected")
            } else if (selectedUsersLength === 1) {
                return selectionHelper.getSingleItemText(selectedUsersArray[0], false)
            } else if (selectedUsersLength > 1) {
                const itemNoun = userNameLower(selectedUsersLength)
                return selectedUsersLength + " " + itemNoun
            }
        }

        const selection = this.userSelectorGroupsStrategy.makeSelectionFromNodeSet(selectedVisibleNodeSet, true, this.mapSelectionGroupsToUsers(), this.getGroupType())
        return selectionHelper.getDescription(selection, dropdownButtonId, true)
    },

    getAllItemsOptionLabelKey: function() {
        return this.allUsersAvailable
               ? this.allUsersOptionLabelKey
               : this.loggedInUserNotInTeam ? this.teamUsersAndMeOptionLabelKey : this.teamUsersItemsOptionLabelKey
    },

    setPredefinedState: function ( predefinedState )
    {
        this.predefinedState = predefinedState
    },

    createComponents: function(){
        ReportsSelectorUsersPanel.superclass.createComponents.call(this)

        this.on("afterlayout", () => {
            if (this._isTeamOnlySwitcherAvailable()) {
                let $container = $(this.el.dom).find('.custom')
                let switcherText = messageResource.getMessage('report.common.user_selector.team_switcher')
                this.showTeamOnlySwither = new SwitcherWithWrapper({
                    containerAdditionalClass: 'teamSwitcherContainer',
                    switcherTextAdditionalClass: "teamSwitcherText",
                    switcherAdditionalClass: "teamSwitcher",
                    onSwitchCallback: show => this._teamSwitchedHandler(show),
                    switcherText: switcherText,
                }).init($container)
                this.showTeamOnlySwither.setState({enabled: this.showTeamOnly})
            }
        })
    },

    _isTeamOnlySwitcherAvailable() {
        return this.manageableUsersIdsSet !== null && this.manageableUsersIdsSet.size !== this.users.length
    },

    _teamSwitchedHandler: function(show) {
        this.showTeamOnly = show
        this.showTeamOnlySwither.setState({enabled: show})
        this.selectorFilter.setShowUsersFromMyTeamOnly(show)
        this.onChange()
    },

    validateIsUsersSelected: function(){
        return !this.isCustomOptionSelected() || !this.getSelection().isEmpty();
    },

    makeSelectionTree: function ()
    {
        //do nothing
    },

    setInitialValueFromCurrent: function(){
        if(this.isAlreadyShown())
        {
            this.setFilterFlag(this.getShowInactive());
            this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()));
            this.setInitialOptionValue( !this.isCustomOptionSelected());
            this.updateInitialTreeSet();
            this.updateInitialGroupType();
            this.showTeamOnlyInit = this.showTeamOnly
        }
    },

    initComponent: function() {
        ReportsSelectorUsersPanel.superclass.initComponent.call( this );
        this.collapsedCookiesKey += "CollapsedUsers";
        this.on("afterlayout", function (){
            const parentNode = this.getEl().findParentNode( "div.at-selector-menu",10,true );
            if( parentNode ) parentNode.addClass("usersSelectorType");
        }, this);
    },

    isStateChanged: function() {
        if (this.isAlreadyShown()) {
            return ReportsSelectorUsersPanel.superclass.isStateChanged.call(this);
        } else {
            return false;
        }
    },

    resetState: function(isEnableActiveActions) {
        if (this._isTeamOnlySwitcherAvailable()) {
            this._teamSwitchedHandler(this.showTeamOnlyInit)
        }

        ReportsSelectorUsersPanel.superclass.resetState.call(this, isEnableActiveActions)
    }
} );

Ext.reg("at_reports_selector_users_panel", ReportsSelectorUsersPanel)

export default ReportsSelectorUsersPanel


// WEBPACK FOOTER //
// ./web/js/reports/at_reports_selector_users_panel.js